require("jquery-validation/dist/jquery.validate")
require("jquery-validation/dist/localization/messages_ru")

$(function () {
  $.validator.addMethod("phonelength", function (value, element) {
    var regexp = /^[78][\d]{10}$/
    return regexp.test(value);
  }, "Номер должен начинаться с 7 или 8 и содержать 11 цифр");
});